import './style.scss'

export default {
   name: 'progress',
   props: { active: false }
}
